<template>
  <div class="form-container">
    <select-box
      :options="options"
      :disabled="disabled"
      @onselect="selectChange"
      form-element
      :title="title"
      :myplaceholder="placeholder"
      class="select-box"
      name="faculty_name"/>
  </div>
</template>
 
<script>
import SelectBox from '@/components/SelectBoxTempNoFilter'
export default {
  name: 'VueSelectTempFacultyNoFilter',
  components: {
    SelectBox
  },
  props: {
    title: String,
    value: String,
    placeholder: String,
    options: Array,
    selectedValue: 14,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectChange (opt) {
      this.$emit('onselect', opt)
    }
  }
}
</script>

<style scoped>
.select-box{
  border-bottom: 1px solid #e4e4e4;
}
  .select__placeholder{
    font-size: 12px;
  }
</style>
